import useAxios from "./service/useAxios";
import { useState, useEffect, useContext, useRef } from "react";
// import AuthenticationContext from "../../../Authentication/AuthenticationContext";
import {
  showSwalQuestion,
  showSwalSuccess,
  showSwalError,
} from "../../../utils/swal";
import CustomButton from "../button/CustomButton";
import { CustomInput } from "../Inputs/Inputs";
const GetName = ({ style, setStep, userInfo, get_mag }) => {
  const { execute: Update_Users } = useAxios("test/Update_Users");
  const [lname, setLname] = useState("");
  const [fname, setFname] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  // const { userInfo, isLogged } = useContext(AuthenticationContext);

  const Update = (e) => {
    e.preventDefault();

    Update_Users({
      keyvalues: `fname,${fname}@@lname,${lname}@@fullname,${fname} ${lname}`,
      conditions: `id/=/${userInfo.id}`,
    })
      .then((data) => {
        if (data.status == 1) {
          setStep(4);
          get_mag();
          // showSwalSuccess("ویرایش مشخصات کاربر با موفقیت انجام شد");
        } else {
          // showSwalError("مشکلی در ویرایش مشخصات کاربر پیش آمده است");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="m-3 " style={style}>
      <form>
        <CustomInput
          type="text"
          label="لطفا نام خود را وارد کنید"
          labelClassName="login-input-label mb-3"
          inputContainer="mb-4 mx-2"
          inputValue={fname}
          placeholder="مثال : محمدرضا"
          // @ts-ignore
          onChangeFunc={(e) => {
            setFname(e.target.value);
          }}
        />
        <CustomInput
          type="text"
          label="لطفا نام خانوادگی خود را وارد کنید"
          labelClassName="login-input-label mb-3"
          inputContainer="mb-4 mx-2"
          inputValue={lname}
          placeholder="مثال : باسط"
          // @ts-ignore
          onChangeFunc={(e) => {
            setLname(e.target.value);
          }}
        />
        <div className="login-button-box">
          <CustomButton
            color="primary"
            className="btn btn-primary px-3 py-2 w-25 justify-content-center"
            btnType="submit"
            onClick={Update}
          >
            ذخیره
          </CustomButton>
        </div>
      </form>
    </div>
  );
};
export default GetName;
